import mixpanel from 'mixpanel-browser';

// 🛡️ ANALYTICS: Powered by Mixpanel
const MIXPANEL_TOKEN = 'a078b3cbb35675f28a237d043c1014a3';

export const AnalyticsService = {
  /**
   * Initializes Mixpanel with Autocapture and Session Replay enabled.
   * Call this once at app boot.
   */
  init: () => {
    try {
      mixpanel.init(MIXPANEL_TOKEN, {
        autocapture: true,
        record_sessions_percent: 100,
        debug: import.meta.env.DEV, // Enable debug logs in development
        track_pageview: true,
      });
      console.log('[AnalyticsService] Mixpanel initialized');
    } catch (error) {
      console.error('[AnalyticsService] Mixpanel init failed:', error);
    }
  },

  /**
   * Tracks a custom event.
   */
  track: (eventName: string, properties?: Record<string, any>) => {
    try {
      mixpanel.track(eventName, properties);
    } catch (error) {
      console.warn(`[AnalyticsService] Failed to track ${eventName}:`, error);
    }
  },

  /**
   * Identifies the current user.
   */
  identify: (userId: string, userProperties?: Record<string, any>) => {
    try {
      mixpanel.identify(userId);
      if (userProperties) {
        mixpanel.people.set(userProperties);
      }
    } catch (error) {
      console.warn('[AnalyticsService] Failed to identify user:', error);
    }
  },

  /**
   * Resets the identity on logout.
   */
  reset: () => {
    try {
      mixpanel.reset();
    } catch (error) {
      console.warn('[AnalyticsService] Failed to reset analytics:', error);
    }
  }
};
